import { render, staticRenderFns } from "./ChiefDeptRegisterRootView.vue?vue&type=template&id=18d11af8"
import script from "./ChiefDeptRegisterRootView.vue?vue&type=script&lang=js"
export * from "./ChiefDeptRegisterRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports